<template>
<layout-content v-if="isShow">
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>

    <section class="legend-list-wrapper">
      <span>审核状态:</span>
      <section class="audit-legend-item info"><div class="legend-section"></div>未审核</section>
      <section class="audit-legend-item warn"><div class="legend-section"></div>退回</section>
      <section class="audit-legend-item success"><div class="legend-section"></div>已审核</section>
      <div style="width:1px;height:60%;margin:0 1em;box-shadow:inset -1px 0 0 0 rgba(222,222,223,.5);"></div>
      <span>数据状态:</span>
      <section class="audit-legend-item success"><div class="legend-section"></div>数据完整</section>
      <section class="audit-legend-item warn"><div class="legend-section"></div>数据不完整</section>
      <section class="audit-legend-item"><div class="legend-section"></div>数据缺失</section>
<!--      <section class="audit-legend-item success"><div class="legend-section"></div>90%以上</section>-->
<!--      <section class="audit-legend-item primary"><div class="legend-section"></div>50%~90%</section>-->
<!--      <section class="audit-legend-item danger"><div class="legend-section"></div>50%以下</section>-->
<!--      <section class="audit-legend-item"><div class="legend-section"></div>数据缺失</section>-->
    </section>
  </template>

  <template #toolbar>
    <template v-if="hasBigScreen">
      <el-button :type="isBigScreen ? 'warning' : 'success'" size="small" @click="bigScreenBtnClick">{{ isBigScreen ? '取消接口访问' : '同意接口访问' }}</el-button>
    </template>

    <el-button icon="el-icon-arrow-left" circle size="small" @click="onBeforeOrAfterAuditTimeChanged(-1)"></el-button>
    <el-date-picker
      v-model="query.auditTime"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd"
      :clearable="false"
      :editable="false"
      size="small"
      style="width:170px;"
      @change="onAuditTimeChanged"
    />
    <el-button icon="el-icon-arrow-right" circle size="small" @click="onBeforeOrAfterAuditTimeChanged(1)"></el-button>

    <!-- <el-popover
      placement="bottom"
      trigger="click"
      popper-class="device-dropdown-selector"
    >
      <template>
        <div class="device-dropdown-selector-wrapper">
          <div class="device-dropdown-selector-wrapper-inner">
            <div
              v-for="device in formatSiteDevices"
              :key="device.id"
              class="device-dropdown-selector"
            >
              <el-checkbox v-model="deviceIds" :label="device.id">{{device.name}}</el-checkbox>
            </div>
          </div>

          <div style="background-color:#EBEEF5;"></div>

          <div style="padding:3px 0;">
            <select-ctrl-group :ids="deviceIds" :options="formatSiteDevices" />
          </div>
        </div>
      </template>
      <template #reference>
        <el-button size="small">选择仪器</el-button>
      </template>
    </el-popover> -->
  </template>

  <template #body>
    <sidebar-content title="站房选择">
      <template #sidebar-body>
        <el-tree
          ref="site-tree"
          :data="treeData"
          accordion
          show-checkbox
          node-key="id"
          :props="defaultProps"
          :default-checked-keys="defaultCheckedKeys"
          :default-expanded-keys="defaultExpandedKeys"
          @node-expand="nodeExpand"
          @check="checkTreeChange"
        >
        </el-tree>
        <!-- <ul class="sidebar-list">
          <li
            v-for="profileSite in profileSites"
            :key="profileSite.id"
            :class="{active: profileSite === currentSite}"
            class="sidebar-item"
            @click="onProfileSiteClick(profileSite)"
          >{{profileSite.name}}</li>
        </ul> -->
      </template>

      <template #sidebar-content-body>
        <div ref="site-device-audit-list" class="site-device-audit-list">
          <div
            v-for="siteDevice in filterSiteDevices"
            :key="siteDevice.id"
            class="site-device-audit-item"
          >
            <div class="site-device-audit-item-header">
              <div>{{siteDevice.name}}</div>

              <div class="btns" v-if="isShowFn(siteDevice)">
                <div
                  type="success"
                  size="mini"
                  icon="el-icon-download"
                  @click="onModelBtnClick(siteDevice)"
                >下载导入模板</div>
                <el-upload
                  ref="upload"
                  :action="`/multiple/integral/upload`"
                  :http-request="onUploadBtnClick"
                  :data="setUploadQuery(siteDevice)"
                  :multiple="false"
                  :show-file-list="false"
                  :drag="false"
                  accept=".csv,.xlsx"
                  style="display:inline-block;"
                >
                  <div type="primary" icon="el-icon-upload" size="mini" @click="setUploadQuery(siteDevice)">导入重积分</div>
                </el-upload>
              </div>
            </div>

            <div class="site-device-audit-item-body">
              <div class="site-device-audit-item-body-inner">
                <div class="site-device-audit-item-body-left">
                  <div class="site-device-audit-item-body-left-header">24小时数据采集情况</div>
                  <div class="hourly-data-info-list">
                    <span
                      v-for="(dataHarvestRate, index) in siteDevice.dataHarvestRates"
                      :key="index"
                      :title="`${new Date(dataHarvestRate.dataTime).format('YYYY-MM-DD HH')} ${Number(dataHarvestRate.harvestRate.toFixed(2))}%`"
                      :has-data="dataHarvestRate.harvestRate"
                      class="hourly-data-info-item"
                    ></span>
                  </div>
                </div>
                <div class="site-device-audit-item-body-center">
                  <div
                    v-for="(n, index) in maxAuditStage"
                    :key="n"
                    :content="`${numberToCN[n]}级审核`"
                    :audited="(1 << index) < Math.abs(siteDevice.auditStage)"
                    :is-back="(1 << index) === Math.abs(siteDevice.auditStage) && siteDevice.auditStage < 0"
                    :style="{width: ((100 - 3 * maxAuditStage) / maxAuditStage + '%')}"
                    class="site-device-audit-item-info"
                    @click="onAuditItemClick(siteDevice, n)"
                    @mouseenter="onAuditDeviceCardMouseover(siteDevice, n, ...arguments)"
                  >
                    <div class="site-device-audit-item-info-org">
                      <div v-if="siteDevice.auditInfos[index]">
                        <div :title="siteDevice.auditInfos[index].orgName">{{siteDevice.auditInfos[index].orgName}}</div>
                        <div>审核人：{{siteDevice.auditInfos[index].auditoryName}}</div>
                        <div>{{siteDevice.auditInfos[index].auditTime}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="site-device-audit-item-body-right">
                  <el-button circle size="small" @click.stop="onOpenMonthDialog(siteDevice)" style="margin: 3px 0;border: none;">
                    <img
                      style="width: 24px;height: 24px"
                      src="../../../assets/imgs/month.png"
                      alt
                      title="月度审核"
                    />
                  </el-button>
                  <el-button circle size="small" @click.stop="showCalendarChart(siteDevice)" style="margin: 3px 0;border: none;">
                    <img
                      style="width: 24px;height: 24px"
                      src="../../../assets/imgs/calendar.png"
                      alt
                      title="审核日历"
                    />
                  </el-button>
                  <el-button circle size="small" @click.stop="showDataStatics(siteDevice)" :disabled="siteDevice.auditInfos.length === 0" v-if="1 & auditAuth === 1 || auditAuth === 3 || isAdmin" style="margin: 3px 0;border: none;">
                    <img
                      style="width: 24px;height: 24px"
                      src="../../../assets/imgs/census.png"
                      alt
                      title="捕集率/有效率"
                    />
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <calendar-editor
            :opened="editorOpened"
            :data="editorData"
            :max-audit-stage="maxAuditStage"
            @onCakendarItemClick="onCakendarItemClick"
          />
          <integral-editor
            ref="integralEditor"
          />
        </div>
      </template>
    </sidebar-content>
  </template>

  <template #editor>
    <div v-if="backReason" class="copy-tip" :style="copyTips">
      <h5 class="back-reason-title">退回原因:</h5>
      <p
        v-html="backReason"
        class="back-reason-value"
      ></p>
    </div>
    <z-dialog :visible="isShowMonthDialog" @close="closeMonthDialog">
      <template #header>月度审核</template>

      <section class="month-wapper">
        <div style="display: flex;justify-content: center;align-items: center;">
          <el-date-picker
            v-model="checkMonthAuditQuery.year"
            type="year"
            placeholder="选择年份"
            :clearable="false"
            :editable="false"
            style="width: 130px;"
          >
          </el-date-picker>
        </div>
        <section>
          <el-button
            v-for="(item, i) in monthDate"
            :key="i"
            :disabled="new Date(new Date(checkMonthAuditQuery.year).getFullYear(), i) > new Date()"
            @click="onMonthBtnClick(i)"
          >
            <span>{{ item }}月</span>
          </el-button>
        </section>
      </section>

      <template #footer>
        <el-button size="small" @click="closeMonthDialog">关闭</el-button>
      </template>
    </z-dialog>
  </template>
</layout-content>
</template>

<script>
import {mapGetters} from 'vuex'
import BaseStore from '../../../components/BaseStore'
import {AUDIT_COMMIT, AUDIT_ITEM_CLICK, SHOW_AUDIT_MAIN} from './EventKeys'
import CSVDownloader from '../../../utils/CSVDownloader'
import numberToCN from '../../../utils/numberToCN'
import SelectCtrlGroup from '../../../components/SelectCtrlGroup/index'
import SidebarContent from '../../../components/Layout/SidebarContent'
import CalendarEditor from './CalendarEditor'
import IntegralEditor from './IntegralEditor'

export default {
  name: 'AuditMain',
  extends: BaseStore,
  components: {SidebarContent, SelectCtrlGroup, CalendarEditor, IntegralEditor},
  props: {
    maxAuditStage: {
      required: true,
      type: Number
    },
    query: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      isShow: true,
      currentSite: {},
      editorOpened: false,
      editorData: {},
      dataStaticsOpened: false,
      auditSiteDevices: [],
      currentSiteDevice: {},
      deviceIds: [],
      activeNames: 0,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      monthDate: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
      isShowMonthDialog: false,
      checkMonthAuditQuery: {
        year: '',
        month: ''
      },
      copyTips: {},
      backReason: '',
      isBigScreen: true
    }
  },
  computed: {
    ...mapGetters({
      lastSelectIds: 'AuditSelectSite/lastSelectIds',
      defaultExpandedKeys: 'AuditSelectSite/defaultExpandedKeys',
      defaultCheckedKeys: 'AuditSelectSite/defaultCheckedKeys'
    }),
    numberToCN: () => numberToCN,
    normalAuditSiteDevices () {
      const bin = process.env.SO2_DEVICE_CATEGORY |
      process.env.NO_DEVICE_CATEGORY |
      process.env.CO_DEVICE_CATEGORY |
      process.env.O3_DEVICE_CATEGORY |
      process.env.PM_DEVICE_CATEGORY
      return this.auditSiteDevices.filter(auditSiteDevice => auditSiteDevice.deviceCategoryId & bin)
    },
    hasBigScreen () {
      // const {normalAuditSiteDevices} = this
      return process.env.BIG_SCREEN && ((1 << (this.maxAuditStage - 1)) & this.auditAuth)/** && normalAuditSiteDevices.length > 0 && normalAuditSiteDevices.every(auditSiteDevice => auditSiteDevice.isAuditOver) */
    },
    // isBigScreen () {
    //   return this.normalAuditSiteDevices.some(auditSiteDevice => auditSiteDevice.bigScreen)
    // },
    formatSiteDevices () {
      let {deviceMap} = this

      return this.auditSiteDevices.map(auditSiteDevice => {
        let {deviceId} = auditSiteDevice
        let device = deviceMap[deviceId]

        return Object.freeze({
          id: auditSiteDevice.id,
          deviceId,
          deviceCategoryId: auditSiteDevice.deviceCategoryId,
          name: device ? (device.name || `${device.brand}${device.model}`) : '',
          auditId: auditSiteDevice.auditId,
          auditStage: auditSiteDevice.auditStage,
          highRange: auditSiteDevice.highRange,
          lowRange: auditSiteDevice.lowRange,
          dataTimeTypeId: auditSiteDevice.dataTimeTypeId,
          dataFrequency: auditSiteDevice.dataFrequency,
          maxDelayTime: auditSiteDevice.maxDelayTime,
          auditManuals: auditSiteDevice.auditManuals,
          dataHarvestRates: auditSiteDevice.dataHarvestRates,
          auditInfos: auditSiteDevice.auditInfos,
          detectionHeights: Object.freeze((auditSiteDevice.height || '').split('|').map(height => Math.round(Number(height) * 1000)))
        })
      })
    },
    filterSiteDevices () {
      let deviceIdMap = this.deviceIds.reduce((map, deviceId) => {
        map[deviceId] = true
        return map
      }, {})
      return this.formatSiteDevices.filter(device => deviceIdMap[device.id])
    },
    siteDeviceMap () {
      return this.profileSiteDevices.reduce((map, el) => {
        if (!map[el.siteId]) {
          map[el.siteId] = []
        }
        map[el.siteId].push({
          ...el,
          id: el.id,
          name: el.name
        })
        return map
      }, {})
    },
    treeData () {
      return this.profileSites.map((el, i) => {
        return {
          ...el,
          index: i,
          parentId: '--',
          children: this.siteDeviceMap[el.id]
        }
      })
    }
  },
  methods: {
    onCakendarItemClick (data) {
      this.query.auditTime = new Date(data.dataTime).format('YYYY/MM/DD')
      this.onAuditItemClick(data.siteDevice, data.stage)
    },
    onBeforeOrAfterAuditTimeChanged (flag) {
      let auditTime = new Date(this.query.auditTime).getTime() + (flag * 86400000)
      this.query.auditTime = new Date(auditTime).format('YYYY/MM/DD')
      this.onAuditTimeChanged()
    },
    onAuditDeviceCardMouseover (siteDevice, n, ev) {
      let tableCon = ev.target
      let range = document.createRange()

      range.selectNodeContents(tableCon)

      let selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('Copy')

      let position = Object.freeze({
        top: `${ev.pageY}px`,
        left: `${ev.pageX}px`
      })
      if (siteDevice.auditInfos[n - 1] && siteDevice.auditInfos[n - 1].status === false) {
        this.copyTips = position
        let backReason = siteDevice.auditInfos[n - 1] ? siteDevice.auditInfos[n - 1].remark : ''
        this.backReason = backReason ? backReason.replace(/\n/g, '<br />') : ''
      } else {
        this.backReason = ''
        this.copyTips = {
          ...position,
          opacity: 0
        }
      }
    },
    onAuditDeviceCardMouseleave () {
      this.backReasonVisibleRef = false
      this.backReason = ''
    },
    onOpenMonthDialog (data) {
      this.currentSiteDevice = data
      this.checkMonthAuditQuery.year = new Date(this.query.auditTime)
      this.isShowMonthDialog = true
    },
    closeMonthDialog () {
      this.isShowMonthDialog = false
    },
    onMonthBtnClick (month) {
      this.checkMonthAuditQuery.month = month
      this.onMonthAuditBtnClick(this.currentSiteDevice)
    },
    onMonthAuditBtnClick (siteDevice) {
      let {year, month} = this.checkMonthAuditQuery
      let monthTime = new Date(new Date(year).getFullYear(), month + 1, 0).format('YYYY/MM/DD')

      let query = {
        siteDeviceId: siteDevice.id,
        auditMonthTime: new Date(monthTime).format('YYYY/MM/DD 00:00:00')
      }
      this.changeLoadStatus(true)

      this.$api.Audit.checkMonthAudit(query).then(data => {
        if (data) {
          this.query.auditTime = monthTime
          this.closeMonthDialog()
          this.onAuditItemClick(siteDevice, (-1 >>> 1))
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    showCalendarChart (siteDevice) {
      let data = {
        isCalendar: true,
        currentSiteDevice: siteDevice,
        currentSite: this.currentSite,
        dateTime: new Date(this.query.auditTime).format('YYYY/MM/DD')
      }
      this.editorData = data
    },
    showDataStatics (siteDevice) {
      let data = {
        isCalendar: false,
        currentSiteDevice: siteDevice,
        currentSite: this.currentSite,
        dateTime: new Date(this.query.auditTime).format('YYYY/MM/DD')
      }
      this.editorData = data
    },
    /**
     * 展开Tree节点时触发
     * 有缓存deviceIds的话 直接设置Tree需选中的仪器
     * 无缓存deviceIds， 默认全选device
    */
    nodeExpand (item) {
      // this.$store.commit('AuditSelectSite/defaultExpandedKeys', [item.id])
      // this.onProfileSiteClick(this.profileSites[item.index])

      // setTimeout(() => {
      //   let {formatSiteDevices} = this
      //   let deviceIds = []
      //   if (this.lastSelectIds.get(item.id)) {
      //     deviceIds = this.lastSelectIds.get(item.id).map(el => el)
      //   } else {
      //     deviceIds = formatSiteDevices.map(el => el.id)
      //   }
      //   this.deviceIds = deviceIds
      //   this.$refs['site-tree'].setCheckedKeys(deviceIds)
      // }, 500)
      this.$store.commit('AuditSelectSite/defaultExpandedKeys', [item.id])
      this.$store.commit('AuditSelectSite/defaultCheckedKeys', [item.id])
      Promise.all([this.onProfileSiteClick(this.profileSites[item.index])]).then(() => {
        let deviceIds = item.children.map(el => el.id)
        this.deviceIds = deviceIds
        this.$refs['site-tree'].setCheckedKeys(deviceIds)
      })
    },
    /**
     * Tree的checkbox 发生改变触发
    */
    checkTreeChange (item, node) {
      if (this.$refs['site-tree'].getCheckedKeys().length === 0) {
        this.deviceIds = []
        return false
      }
      if (item.parentId === '--') {
        Promise.all([this.onProfileSiteClick(this.profileSites[item.index])]).then(() => {
          this.$store.commit('AuditSelectSite/defaultExpandedKeys', [item.id])
          this.$store.commit('AuditSelectSite/defaultCheckedKeys', [item.id])
          let checkNodeIds = this.formatSiteDevices.map(el => el.id)
          // 设置选中仪器
          this.deviceIds = checkNodeIds
          // 缓存选中仪器
          // this.$store.commit('AuditSelectSite/lastSelectIds', {id: item.id, data: checkNodeIds})
          // 设置Tree选中
          let node = this.$refs['site-tree'].getNode(item.id)
          this.$refs['site-tree'].setCheckedKeys([item.id], !node.checked)
          // 设置展开
          let treeData = this.treeData
          treeData.forEach(el => {
            let node = this.$refs['site-tree'].getNode(el.id)
            if (node.data.id === item.id) {
              node.expanded = true
            } else {
              node.expanded = false
            }
          })
        })
      } else {
        // this.$store.commit('AuditSelectSite/defaultExpandedKeys', [item.parentId])
        let checkNodeIds = node.checkedNodes.filter(el => el.parentId !== '--').map(el => el.id)
        this.deviceIds = checkNodeIds
        // this.$store.commit('AuditSelectSite/lastSelectIds', {id: item.parentId, data: checkNodeIds})
      }
    },
    /**
     * Tree 懒加载
    */
    // onLoadTree (node, resolve) {
    //   if (node.level === 0) {
    //     return resolve(this.treeData)
    //   }

    //   if (node.level === 1) {
    //     this.onProfileSiteClick(this.profileSites[node.data.index])
    //     setTimeout(() => {
    //       if (this.defaultExpandedKeys.length > 0) {
    //         setTimeout(() => {
    //           this.$refs['site-tree'].setCheckedKeys(this.lastSelectIds.get(this.defaultExpandedKeys[0]).map(el => el))
    //         }, 10)
    //       }
    //       return resolve(this.formatSiteDevices.map(el => {
    //         return {
    //           ...el,
    //           parentId: node.data.id,
    //           checked: true,
    //           leaf: true
    //         }
    //       }))
    //     }, 700)
    //   }
    // },
    setProfileSite () {
      let {profileSites} = this

      if (profileSites.length > 0) {
        this.setCurrentSite(profileSites[0])

        // setTimeout(() => {
        //   this.onAuditItemClick(this.auditSiteDevices[0], 1)
        // }, 500)
      }
    },
    getShowBigScreenFlag () {
      const bigScreenFlag = process.env.BIG_SCREEN
      if (!bigScreenFlag) {
        return
      }

      this.changeLoadStatus(true)
      const { query } = this
      this.$api.Audit.getShowBigScreenFlag({
        siteId: query.siteId,
        dataTime: query.auditTime
      }).then(flag => {
        this.isBigScreen = flag
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getAuditSiteDevices (isSetScrollTop) {
      this.changeLoadStatus(true)

      this.$api.Audit.getAuditSiteDevices(this.query).then(auditSiteDevices => {
        const startHour = process.env.AUDIT_BEGIN_HOUR
        let {auditTime} = this.query
        let date = new Date(auditTime)

        let dates = new Array(24).fill(0).map((n, index) => {
          date.setHours(startHour + index)
          return date.format('YYYY/MM/DD HH:mm:ss')
        })

        auditSiteDevices.forEach(auditSiteDevice => {
          let {auditStage = 1, dataHarvestRate = [], auditInfos = []} = auditSiteDevice
          let dataHarvestRateMap = dataHarvestRate.reduce((map, dataHarvestRate) => {
            map[dataHarvestRate.dataTime] = dataHarvestRate
            return map
          }, {})

          dataHarvestRate = dates.map(date => {
            let dataHarvestRate = dataHarvestRateMap[date]
            return Object.freeze({
              dataTime: date,
              harvestRate: dataHarvestRate && dataHarvestRate.hasOwnProperty('harvestRate') ? dataHarvestRate.harvestRate : 0
            })
          })

          auditInfos.forEach(auditInfo => {
            Object.freeze(auditInfo)
          })

          auditSiteDevice.dataHarvestRates = Object.freeze(dataHarvestRate)
          auditSiteDevice.auditStage = auditStage
          auditSiteDevice.auditInfos = Object.freeze(auditInfos)
          Object.freeze(auditSiteDevice)//
        })

        // 缓存SiteDeviceIds
        // if (!this.lastSelectIds.get(this.query.siteId)) {
        //   this.$store.commit('AuditSelectSite/lastSelectIds', {id: this.query.siteId, data: auditSiteDevices.map(el => el.id)})
        // }

        this.auditSiteDevices = Object.freeze(auditSiteDevices)

        if (isSetScrollTop) {
          let wrapper = this.$refs['site-device-audit-list']

          if (wrapper) {
            wrapper.scrollTop = 0
          }
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onProfileSiteClick (profileSite) {
      if (profileSite === this.currentSite) {
        return
      }

      this.setCurrentSite(profileSite)
    },
    setCurrentSite (profileSite) {
      if (!profileSite) return
      this.changeSite = true
      this.currentSite = profileSite
      this.query.siteId = profileSite.id

      this.getShowBigScreenFlag()
      this.getAuditSiteDevices(true)
    },
    onAuditTimeChanged () {
      this.getShowBigScreenFlag()
      this.getAuditSiteDevices(true)
    },
    isShowFn (siteDevice) {
      let siteDeviceCategory = process.env.LIDAR_DEVICE_CATEGORY + process.env.PARTICLE_SIZE_SPECTRUM_DEVICE_CATEGORY + process.env.WIND_PROFILE_CATEGORY
      let {deviceCategoryId} = siteDevice
      let max = 1 << 30

      if (deviceCategoryId > max) {
        deviceCategoryId = (deviceCategoryId / max) | 0
        siteDeviceCategory = (siteDeviceCategory / max) | 0
      }

      if (siteDevice.auditStage > 1) {
        return false
      }

      if (!(siteDeviceCategory & deviceCategoryId)) {
        return true
      }

      return false
    },
    onAuditItemClick (siteDevice, stage) {
      let auditAuth = this.auditAuth

      if (this.isAdmin || ((1 << (stage - 1)) & auditAuth) || (((1 << this.maxAuditStage) - 1) & auditAuth) >= this.maxAuditStage) {
        this.isShow = false

        this.$eventBus.emit(AUDIT_ITEM_CLICK, {
          site: this.currentSite,
          siteDevice,
          stage
        })

        this.$store.commit('Profile/showSideNav', false)
      } else {
        this.$notify({
          title: '错误',
          message: '您没有该阶段的审核权限',
          type: 'error',
          position: 'bottom-right'
        })
      }
    },
    onShowAuditMain () {
      this.$store.commit('Profile/showSideNav', true)
      this.isShow = true
    },
    onAuditSubmit () {
      this.getAuditSiteDevices(false)
      this.isShow = true
    },
    // 下载重积分导入模板
    onModelBtnClick (siteDevice) {
      let {profileSiteDeviceMap, query: {auditTime}} = this
      let device = profileSiteDeviceMap[siteDevice.id]

      let factors = device.siteDeviceFactors.filter(el => el.status)
      // let firstColumn = [''].concat(factors.map(el => el.stdUnit))
      let secondColumn = ['日期'].concat(factors.map(el => el.name))

      let nullVal = Array.from({length: 24}, () => '')
      let temp = []
      nullVal.forEach((el, i) => {
        let data = [auditTime + ' ' + i + ':00:00'].concat(Array.from({length: device.siteDeviceFactors.length}, () => ''))
        temp.push(data)
      })

      CSVDownloader([secondColumn, ...temp], device.name + '重积分数据上传模板')
    },
    // 设置上传Query
    setUploadQuery (siteDevice) {
      let {query} = this
      let uploadQuery = {
        ...query,
        siteDeviceId: siteDevice.id
      }

      return uploadQuery
    },
    // 上传重积分
    onUploadBtnClick (uploadObj) {
      this.changeLoadStatus(true)

      this.$api.Integral.upload(uploadObj)
        .then(backData => {
          this.setBackData(backData)
        })
        .catch(console.error)
        .finally(() => {
          this.changeLoadStatus(false)
        })
    },
    setBackData (backData) {
      let {factorMap, filterSiteDevices, profileSiteDeviceMap, query: {siteId}} = this

      let filterSiteDeviceMap = filterSiteDevices.reduce((map, el) => {
        map[el.id] = el
        return map
      }, {})

      if (backData.aliasSet && backData.aliasSet.length > 0) {
        // 取该仪器所有因子Map
        let siteFactorsMap = profileSiteDeviceMap[backData.siteDeviceId].siteDeviceFactors.reduce((map, el) => {
          map[el.factorId] = el
          return map
        }, {})

        let {factorIds} = backData
        let factors = factorIds.map(el => siteFactorsMap[el])

        this.onEditBtnClick({
          factors: factors,
          errorBackData: backData.aliasSet.map(el => {
            return {
              alias: el,
              factorId: ''
            }
          }),
          backData: backData,
          siteDeviceId: backData.siteDeviceId,
          siteId: siteId,
          filterSiteDeviceMap: filterSiteDeviceMap
        })
      } else {
        if (backData.isSave) {
          if (backData.isDelete) {
            this.$notify({
              type: 'success',
              position: 'bottom-right',
              message: `删除成功!`
            })
            return
          }

          this.$notify({
            type: 'success',
            position: 'bottom-right',
            message: `导入成功! ${backData.errRatio ? '错误率：' + backData.errRatio + '%(<20%容错率)' : ''}`
          })
        } else if (backData.isSave === false) {
          let factorNames = backData.noSiteDeviceFactorIds.map(item => {
            return factorMap[item].name
          })

          this.$notify({
            type: 'error',
            position: 'bottom-right',
            message: `导入失败! ${backData.errRatio ? '错误率：' + backData.errRatio + '%(>20%容错率)' : ''}
              ${filterSiteDeviceMap[backData.siteDeviceId].name}不包含${factorNames.join(',')}因子
            `
          })
        }
      }
    },
    onEditBtnClick (data) {
      this.$refs.integralEditor.open(data)
    },
    // JSON 按属性去重 data（去重的JSON） Name（属性名）
    FilterByName (data, Name) {
      let dest = []

      for (let i = 0; i < data.length; i++) {
        let ai = data[i]

        if (i === 0) {
          dest.push(ai)
        } else {
          let filterData = dest.filter(function (e) {
            return e[Name] === ai[Name]
          })

          if (filterData.length === 0) {
            dest.push(ai)
          }
        }
      }
      return dest
    },
    bigScreenBtnClick () {
      const {query} = this
      this.changeLoadStatus(true)
      this.$api.Audit.setBigScreen({
        auditTime: query.auditTime,
        siteId: query.siteId,
        bigScreen: !this.isBigScreen
      }).then(() => {
        this.isBigScreen = !this.isBigScreen
        // this.getAuditSiteDevices(false)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  watch: {
    profileSites: {
      immediate: true,
      handler (newVal) {
        if (Array.isArray(newVal)) {
          // 设置默认选中的Tree 2023-08-15改的tree 17：44提交
          if (newVal.length > 0) {
            this.setProfileSite()
            this.$store.commit('AuditSelectSite/defaultCheckedKeys', [newVal[0].id])
          }
        }
      }
    },
    auditSiteDevices (auditSiteDevices) {
      if (this.changeSite) {
        // this.deviceIds = auditSiteDevices.length < 5 ? auditSiteDevices.map(device => device.id) : [auditSiteDevices[0].id]
        this.deviceIds = auditSiteDevices.map(device => device.id)
        if (this.defaultExpandedKeys.length > 0) {
          setTimeout(() => {
            this.deviceIds = this.siteDeviceMap[this.defaultExpandedKeys[0]].map(el => el.id)
          }, 0)
        }
        this.changeSite = false
      }
    }
  },
  created () {
    let {$eventBus} = this
    $eventBus.on(SHOW_AUDIT_MAIN, this.onShowAuditMain)
    $eventBus.on(AUDIT_COMMIT, this.onAuditSubmit)
    this.$store.commit('Profile/showSideNav', true)
  },
  beforeDestroy () {
    let {$eventBus} = this
    $eventBus.off(SHOW_AUDIT_MAIN, this.onShowAuditMain)
    $eventBus.off(AUDIT_COMMIT, this.onAuditSubmit)
  }
}
</script>

<style lang="scss" scoped>
.legend-list-wrapper {
  font-size: .875em;
  display: flex;
  align-items: center;
  float: left;
  height: 100%;
  line-height: 2rem;
  margin-left: 2em;
  color: #303133;
  user-select: none;

  > .audit-legend-item {
    display: flex;
    align-items: center;
    float: left;
    margin-left: 1em;

    &.info {
      > .legend-section {
        background-color: #909399;
      }
    }

    &.warn {
      > .legend-section {
        border: 1px solid #E6A23C;
        background-color: #E6A23C;
      }
    }

    &.success {
      > .legend-section {
        border: 1px solid #67C23A;
        background-color: #67C23A;
      }
    }

    &.primary {
      > .legend-section {
        border: 1px solid #409EFF;
        background-color: #409EFF;
      }
    }

    &.danger {
      > .legend-section {
        border: 1px solid #F56C6C;
        background-color: #F56C6C;
      }
    }

    > .legend-section {
      display: inline-block;
      width: .75em;
      height: .75em;
      margin-right: .5em;
      vertical-align: middle;
      border: 1px solid #909399;
    }
  }
}

.site-device-audit-list {
  width: 100%;
  height: 100%;
  padding: 0 12px 0 0;
  overflow: auto;
  user-select: none;

  > .site-device-audit-item {
    min-width: 898px;

    & + .site-device-audit-item {
      margin-top: 5px;
    }

    > .site-device-audit-item-header {
      font: {
        size: 0.8rem;
        weight: 700;
      };
      width: 100%;
      height: 1.7em;
      line-height: 1.7;
      padding: 0 1em;
      /*background: linear-gradient(to right, #fbc15a 0%, #FFF 100%);*/
      background: linear-gradient(to right, #00c0ef 0%, #FFF 100%);
      color: #ffffff;

      display: flex;
      justify-content: space-between;

      .btns {
        display: flex;
        align-items: center;
        color: #303133;

        > div {
          margin-right: 10px;
          cursor: pointer;
        }

        :hover {
          color: #409EFF;
        }
      }
    }

    > .site-device-audit-item-body {
      position: relative;
      height: 75px;
      padding: 6px 2.6%;
    }

    .site-device-audit-item-body-inner {
      $LEFT-WIDTH: 210px;
      $RIGHT-WIDTH: 60px;

      position: relative;
      width: 100%;
      height: 100%;
      padding: 0 $RIGHT-WIDTH 0 $LEFT-WIDTH;

      > {
        * {
          height: 100%;
        }

        .site-device-audit-item-body-left,
        .site-device-audit-item-body-right {
          position: absolute;
          top: 0;
          text-align: center;
        }

        .site-device-audit-item-body-left {
          font-size: .675rem;
          left: 0;
          width: $LEFT-WIDTH;
          line-height: 1.7142857142857142;
          border-radius: 5px;
          color: #909399;
          box-shadow: 0 0 4px 1px rgba(0, 0, 0, .1);

          > .site-device-audit-item-body-left-header {
            padding-top: 3px;
          }

          > .hourly-data-info-list {
            font-size: 0;
            margin-top: 3px;
            padding: 0 11px;

            > .hourly-data-info-item {
              display: inline-block;
              width: 9px;
              height: 11px;
              margin: 3px;
              background-color: #E6A23C;

              &[has-data="0"] {
                background-color: #f6f6f6;
              }

              &[has-data="100"] {
                background-color: #67C23A;
              }

              &:hover {
                box-shadow: 0 0 2px 0 rgba(0, 0, 0, .2);
                transform: scale(1.3, 1.3);
              }
            }
          }
        }

        .site-device-audit-item-body-center {
          $ITEM-HEIGHT: 75px;
          width: 100%;

          > .site-device-audit-item-info {
            position: relative;
            float: left;
            height: 100%;
            min-width: 130px;
            max-width: 270px;
            margin-left: 3%;
            padding-left: $ITEM-HEIGHT;
            border: {
              radius: 5px;
            }
            background-color: #f6f6f6;
            box-shadow: 0 0 4px 1px rgba(0, 0, 0, .1);
            overflow: hidden;
            cursor: pointer;
            user-select: none;

            &[audited="true"] {
              background-color: #e1f3d8;

              &:before {
                background-color: #67C23A;
              }

              &:after {
                border-left-color: #67C23A;
              }
            }

            &[is-back="true"] {
              background-color: #faecd8;

              &:before {
                background-color: #E6A23C;
              }

              &:after {
                border-left-color: #E6A23C;
              }
            }

            &:hover {
              transform: scale(1.05, 1.05);
            }

            &:before {
              content: attr(content);
              position: absolute;
              font: {
                size: 17px;
                weight: 600;
              }
              display: flex;
              justify-content: center;
              align-items: center;
              top: 0;
              left: 0;
              width: $ITEM-HEIGHT;
              height: 100%;
              line-height: 1.5;
              padding: 12px 0 12px .5em;
              background-color: #cdcdcd;
              color: #ffffff;
              text-align: center;
              letter-spacing: .5em;
            }

            &:after {
              content: "";
              position: absolute;
              top: 0;
              bottom: 0;
              left: $ITEM-HEIGHT;
              height: 0;
              margin: auto 0;
              border: 6px solid transparent {
                left-color: #cdcdcd;
              }
            }
          }

          .site-device-audit-item-info-org {
            font: {
              size: 0.64rem;
              weight: 700;
            };
            line-height: 1.5;
            color: #303133;

            > * {
              padding: 4px 20px;
              text-align: center;

              > * {
                width: 100%;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
            }

            &:empty:before {
              content: "未审核";
              font: {
                size: 17px;
                weight: 600;
              }
              display: block;
              width: 100%;
              height: 100%;
              line-height: 65px;
              text-align: center;
              letter-spacing: .5em;
              color: #606266;
            }
          }
        }

        .site-device-audit-item-body-right {
          right: 0;
          min-width: 80px;
          max-width: 130px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          border: 1px solid #00c0ef;
          border-radius: 30px;
          padding: 5px;
          margin: 0 2px;
        }
      }
    }
  }
}

.device-dropdown-selector-wrapper {
  display: grid;
  grid-template-rows: auto 1px max-content;
  min-height: 350px;
  max-height: 600px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .device-dropdown-selector-wrapper-inner {
    padding: 12px;
    overflow: auto;
  }

  .device-dropdown-selector {
    line-height: 1.7;
    -webkit-font-smoothing: antialiased;
  }
}
.el-collapse /deep/ .el-collapse-item__header {
  padding-left: 10px;
}
</style>

<style scoped lang="scss">
.device-dropdown-selector {
  padding: 0 !important;
}
.month-wapper {
  width: 25rem;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: max-content auto;
  grid-gap: 10px;

  > section {
    width: 25rem;
    height: 25rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr;
    grid-gap: 10px;

    > .el-button {
      width: 100%;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-size: 20px;
        font-weight: bold;
      }

      &:hover {
        background: #EBEEF5;
      }
    }
  }
}
.copy-tip {
  position: fixed;
  font-size: 12px;
  background-color: #e6a23c;
  padding: 10px;
  border-radius: 4px;
  line-height: 1;
  z-index: 999;
  color: #FFFFFF;
  pointer-events: none;

  > h5 {
    margin: 0 0 5px 0;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditMain.vue